import { render } from "./DocumentDetailModal.vue?vue&type=template&id=4a02120e"
import script from "./DocumentDetailModal.vue?vue&type=script&lang=js"
export * from "./DocumentDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__